import { BaseObject } from './../shared/baseClass';
import { ExecFileOptionsWithStringEncoding } from 'child_process';

export class Settings extends BaseObject {
  id: string;
  emailGuestPays: boolean;
  emailUpdates: boolean;
  emailWhenRsvpReceived: boolean;
  stripePublicKey: string;
  feeOption: number;
  stripeAccountId: string;
  payoutsEnabled: boolean;
  chargesEnabled: boolean;
  stripeSetupLink: string;
  capabilities: any;
  verification: any;
  emailTitleOverride: string;
  emailDescriptionOverride: string;
  registryEnabled: boolean;
  weddingWebsiteEnabled:boolean;
  enableTranslations: boolean;
  secondLanguage: string;
  defaultLanguage: string;
  translationsInProgress: boolean;
  dismissOverviewIntro: boolean;
  completedWebsiteOnboarding: boolean;
  completedRegistryOnboarding: boolean;
  completedGuestListOnboarding: boolean;
  hasUpdatedGuestList: boolean;
  maxGuests: number;
  disabledQuickThanks?: boolean;
  dismissAiGiftsNotification: boolean;
  merchantId: string;
  payengineStatus: string;
}







// WEBPACK FOOTER //
// ./src/app/settings/settings.ts